export const DEVICE_VERIFICATION_ERROR = 'Unable to verify this device. Restart PipeeX or contact support.';
export const PLUGIN_UPDATE_ERROR = 'This plugin cannot verify this device. Update PipeeX and try again.';
export const INVALID_FINGERPRINT_ERROR = 'A valid machine fingerprint is required. Update PipeeX and try again.';

function isDotNetWhitespace(code: number): boolean {
  return (code >= 0x09 && code <= 0x0d)
    || code === 0x20
    || code === 0x85
    || code === 0xa0
    || code === 0x1680
    || (code >= 0x2000 && code <= 0x200a)
    || code === 0x2028
    || code === 0x2029
    || code === 0x202f
    || code === 0x205f
    || code === 0x3000;
}

/** Normalize transport identity only; never derive an identity in the browser. */
export function normalizeMachineFingerprint(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  // Match .NET String.Trim whitespace, including NEL but excluding BOM.
  let start = 0;
  let end = value.length;
  while (start < end && isDotNetWhitespace(value.charCodeAt(start))) start++;
  while (end > start && isDotNetWhitespace(value.charCodeAt(end - 1))) end--;
  if (end - start !== 71) return null;
  const normalized = value.slice(start, end).replace(/[A-Z]/g, (letter) => letter.toLowerCase());
  return /^win-v1:[0-9a-f]{64}$/.test(normalized)
    ? normalized
    : null;
}
